import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { ConditionGeoDistanceInput } from './ConditionGeoDistanceInput';
import { TextSecondary, FlexWrapper } from './ConditionGeoLocation.styles';
import { ConditionSingleValueGeolocationProps } from '../types';
import { useGeoLocationHandlers } from './hooks/useGeoLocationHandlers';
import { ConditionGeoLocationInputs } from './ConditionGeoLocationInputs';

export const DATA_TEST = {
  wrapper: 'condition-geoLocation-wrapper',
};

export const ConditionGeoLocation = ({
  value: initialValue,
  onChange,
  ...props
}: ConditionSingleValueGeolocationProps) => {
  const { t } = useTranslation();
  const { value, onGeoDistanceChange, onGeoLocationChange } = useGeoLocationHandlers({
    value: initialValue,
    onChange,
  });

  return (
    <FlexWrapper data-test={DATA_TEST.wrapper}>
      <ConditionGeoDistanceInput
        {...props}
        value={value?.distance ?? null}
        onChange={onGeoDistanceChange}
      />
      <TextSecondary>{t('storybook.geoLocation.preposition')}</TextSecondary>
      <ConditionGeoLocationInputs
        {...props}
        placeholder=""
        value={value?.location ?? null}
        onChange={onGeoLocationChange}
      />
    </FlexWrapper>
  );
};
